import { type PricePolicyContent, usePricePolicyContentQuery } from '@libs/common-next';
import { getPriceDisplay, type PriceDisplay } from '@libs/shared-ui';

import { useProduct } from '@/entities/product';

type UsePriceResult = PriceDisplay & {
    pricePolicy: Nullable<PricePolicyContent>;
};

export const usePrice = (): UsePriceResult => {
    const { product } = useProduct();
    const { pricePolicyData } = usePricePolicyContentQuery();

    if (!product) {
        return { values: [], variant: 'primary', pricePolicy: null };
    }

    const oneTimePrice = getPriceDisplay(product);
    const hasPricePolicy = Boolean(pricePolicyData?.title) && Boolean(pricePolicyData?.content);

    return {
        ...oneTimePrice,
        pricePolicy:
            oneTimePrice.variant === 'disabled' && hasPricePolicy ? (pricePolicyData as PricePolicyContent) : null,
    };
};
